import { Injectable } from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  CanLoad, Route } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const url: string = state.url;

    return this.checkSignin(url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): boolean {
    const url = `/${route.path}`;

    return this.checkSignin(url);
  }

  checkSignin(url: string): boolean {
    if (this.authService.isSignedIn) { return true; }

    // Сохраняем URL для перехода после аунтификации
    this.authService.redirectUrl = url;

    this.router.navigate(['/signin']);
    return false;
  }
}



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/_services/auth-guard.service.ts